






















































import Vue from "vue";
import Component from "vue-class-component";
import { locales } from "../../locale";

@Component
export default class AppLocalization extends Vue {
  locales = locales;

  get currentLocale() {
    return this.$store.getters.locale;
  }

  getLocale() {
    return this.lodash.find(
      this.locales,
      (val) => val.locale === this.currentLocale
    ).title;
  }

  async setLocale(locale) {
    this.$vuetify.lang.current = locale;
    await this.$store.dispatch("SetLocale", { locale });
    window.location.reload();
  }
}
